module.exports = __webpack_public_path__ + "static/img/01.af204c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/04/01.jpg
// module id = Dhgg
// module chunks = 1